export class Substitution {

  starterId;
  subId;
  subOffId;
  substitutedAt;
  rating;

  constructor (substitution = {}) {
    this.starterId = substitution.starterId;
    this.subId = substitution.subId;
    this.subOffId = substitution.subOffId;
    this.substitutedAt = substitution.substitutedAt;
    this.rating = substitution.rating;
  }
}